import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { agentTasksKeys } from './agentTasks.keys';
import { getAgentTasks, deleteAgentTask, updateAgentTask } from './agentTasks.api';
export const useAgentTasksQuery = () => {
    return useQuery({
        queryKey: agentTasksKeys.all(),
        queryFn: getAgentTasks,
        refetchInterval: 5000,
        staleTime: 0
    });
};
export const useUpdateAgentTaskMutation = () => {
    return useMutation({
        mutationFn: updateAgentTask,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: agentTasksKeys.all() }).then();
        }
    });
};
export const useDeleteAgentTaskMutation = () => {
    return useMutation({
        mutationFn: deleteAgentTask,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: agentTasksKeys.all() }).then();
        }
    });
};
//# sourceMappingURL=agentTasks.query.js.map